module.exports = "<!--<button class=\"btn btn-primary\" (click)=\"openDlg()\">Get a quote</button>-->\n<router-outlet></router-outlet>\n"